import TickIcon from "../../../assets/images/tick1.svg"
import { CircularLoader } from "../../../components"

function formatDateWithOrdinal(dateString) {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });

  // Get ordinal suffix
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  };

  return `${month} ${day}${getOrdinal(day)}`;
}

export default function AnnouncementItem({ id, subject, message, createdAt, isRead, isLoading, showPopup, markAsRead }) {
  return (
    <div
      className="px-0 mb-4 cursor-pointer"
      onClick={(e) => {
        // Don't trigger if clicking on the "Mark as read" button
        if (!e.target.closest('.mark-as-read-button')) {
          showPopup(e, message, id);
        }
      }}
      >
      <div className="flex items-center gap-3">
        <div className="text-xs text-[#6B7280]">{formatDateWithOrdinal(createdAt)}</div>
        {!isRead && <div className="bg-[#DBEAFE] px-2 py-1 rounded-xl text-[10px] text-[#1E40AF]">Unread</div>}
      </div>

      <div className="mt-1 pt-3 pb-3 relative hover:bg-[#F8FAFC]">
        <div className="font-bold text-[#1F2937] pb-1">{subject}</div>
        {!isRead && (
          <div 
            className={`absolute right-0 top-0 flex items-center gap-2 font-inter text-sm pt-2 ${
              isLoading 
                ? 'text-[#6B7280] cursor-not-allowed' 
                : 'text-[#0D9488] cursor-pointer hover:text-[#0F766E]'
            }`} 
            onClick={isLoading ? undefined : (e) => {
              e.stopPropagation();
              markAsRead(id);
            }}
          >
            {isLoading ? (
              <>
                <span>Marking as read...</span>
                <CircularLoader className="w-4 h-4" />
              </>
            ) : (
              <>
              <button className="
                mark-as-read-button
                flex items-center gap-2
                bg-transparent border border-teal text-teal
                hover:bg-teal hover:bg-opacity-10
                text-center py-1 px-2 rounded-md
                transition-all duration-200 md:text-sm text-xs
              ">
                <span>Mark as read</span>
                <img className="w-4 h-4" src={TickIcon} alt="Mark as read" />
              </button>
                
              </>
            )}
          </div>
        )}
        <div className="text-xs font-inter text-[#1F2937] overflow-hidden text-ellipsis whitespace-pre-wrap line-clamp-2" dangerouslySetInnerHTML={{ __html: message }}>
        </div>
      </div>
      
    </div>
  );
}
